// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Answer-Main-index-root-30t8C","layoutWrap":"src-components-Answer-Main-index-layoutWrap-32ZIG","doubleLayout":"src-components-Answer-Main-index-doubleLayout-1EoDK","explain":"src-components-Answer-Main-index-explain-1jUa7","questionContent":"src-components-Answer-Main-index-questionContent-3kt_o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Answer/Main/index.css
 ** module id = 256
 ** module chunks = 0
 **/